const logger = (error) => {
    console.error("error", error)
}

export { logger }